import * as React from "react";
import {
  useDataMutableSourceSuccessClientStorageData,
  useDataMutableSourceSuccessClientStorageData_asController,
} from "../data-mutable-source-success-client-storage-data";

import { useDataSourceMyBagTotalsController } from "../data-source--mybag-totals-provider";

export interface SuccessPresenterConsumer {
  isLoading: boolean;
}
const defaultValue = {} as unknown as SuccessPresenterConsumer;
const SuccessPresenterContext = React.createContext(defaultValue);

export interface SuccessPresenterController {
  handleSuccessPageAppeared: () => void;
}
const defaultControllerValue = {} as unknown as SuccessPresenterController;
const SuccessPresenterControllerContext = React.createContext(
  defaultControllerValue
);

export const SuccessPresenter: React.FunctionComponent = (props) => {
  const { isLoading: dataMutableSourceSuccessClientStorage_isLoading } =
    useDataMutableSourceSuccessClientStorageData();
  const { handleRequireCacheData } =
    useDataMutableSourceSuccessClientStorageData_asController();
  const { enablePoolingInvalidations } = useDataSourceMyBagTotalsController();

  const isLoading = React.useMemo(() => {
    return dataMutableSourceSuccessClientStorage_isLoading;
  }, [dataMutableSourceSuccessClientStorage_isLoading]);

  const handleSuccessPageAppeared: SuccessPresenterController["handleSuccessPageAppeared"] =
    React.useCallback(() => {
      enablePoolingInvalidations();
      handleRequireCacheData();
    }, [enablePoolingInvalidations, handleRequireCacheData]);

  const value: SuccessPresenterConsumer = React.useMemo(
    () => ({
      isLoading,
    }),
    [isLoading]
  );
  const controllerValue: SuccessPresenterController = React.useMemo(
    () => ({
      handleSuccessPageAppeared,
    }),
    [handleSuccessPageAppeared]
  );
  return (
    <SuccessPresenterContext.Provider value={value}>
      <SuccessPresenterControllerContext.Provider value={controllerValue}>
        {props.children || []}
      </SuccessPresenterControllerContext.Provider>
    </SuccessPresenterContext.Provider>
  );
};

export const useSuccessPresenter = () => {
  const context = React.useContext(SuccessPresenterContext);
  if (context === defaultValue) {
    throw new Error(
      "useSuccessPresenter must be used within a SuccessPresenterProvider"
    );
  }
  return context;
};

export const useSuccessPresenter_asController = () => {
  const context = React.useContext(SuccessPresenterControllerContext);
  if (context === defaultControllerValue) {
    throw new Error(
      "useSuccessPresenter_asController must be used within a SuccessPresenterProvider"
    );
  }
  return context;
};
